import React from 'react'
import * as S from './ArtboardDetailInspectorOverlay.styles'
import { PRRect } from '@sketch-hq/sketch-web-renderer'
import { useMapPRRectToCanvasRelativeRect } from '../../hooks/inspector'

export type HoveredLayerOverlayProps = {
  bounds: PRRect
}

export function HoveredLayerOverlay({ bounds }: HoveredLayerOverlayProps) {
  const canvasRelativeRect = useMapPRRectToCanvasRelativeRect(bounds)

  if (!canvasRelativeRect) {
    return null
  }

  return (
    <S.LayerOverlay
      $borderSize={2}
      $color="blue"
      $width={canvasRelativeRect.width}
      $height={canvasRelativeRect.height}
      $x={canvasRelativeRect.x}
      $y={canvasRelativeRect.y}
    />
  )
}
